import { useParams, Link, useNavigate } from "react-router-dom";
import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

// import PreviousNext from '../common/previous-next';
import BasicSpinner from '../common/basic-spinner';
// import ListView from '../common/list-view';
import PaginatedList from '../common/pagination';

import ImageDetails from '../image/image-details';

import { fetchPublicImage, fetchPublicImageParents } from '../../utils/fetch-helpers';
import { useAuth } from "../../utils/auth-provider";

//================================================================

export default function ImagePage(){

  const navigate = useNavigate();
  const user = useAuth();
  const params = useParams();

  const [parents, setParents] = useState(null);
  const [image, setImage] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(true);

  //----------------------------------------------------------------

  const fetchImage = useCallback( async (imageId, signal) => {
    setImage(await fetchPublicImage(imageId, signal));
  }, [params.imageId]);

  //----------------------------------------------------------------

  const fetchParents = useCallback(async (imageId, signal) => {
    setParents(await fetchPublicImageParents(imageId, signal));
  }, [image]);

  //----------------------------------------------------------------

  useEffect(() => {
    if (!image) return;

    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchParents(image._id, signal);

    return () => abortController.abort();
  }, [image]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchImage(params.imageId, signal);

    return () => abortController.abort();
  }, [params.imageId]);

  //----------------------------------------------------------------

  return(
    <>
      {/*<PreviousNext
        objects={images}
        currentObject={image}
        onClick={setCurrentImage}
        basePath={`/image`}
      />*/}
      { !image ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>

          <Row className="mb-2 align-items-center">
            <Col className="h4 text-truncate" sm={9}>
              <b>{"Image: "}</b>{image.name || ""}
            </Col>
            { user.isAuthenticated &&
              <Col sm={3}>
                <Link to={`/dashboard/image/${image._id}`}>
                  <Button className="text-nowrap w-100">
                    View Your Item
                  </Button>
                </Link>
              </Col>
            }
          </Row>

          <ImageDetails image={image}/>

          <Row className='mb-2 align-items-center'>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button
                className="w-100"
                onClick={() => navigate(1)}
              >
                Forward
              </Button>
            </Col>
          </Row>

          {/* Parents Section*/}
          { parents &&
            <>
              <hr />

              <Row className="mb-3 align-items-center">
                <Col className="h4 my-0 text-start">Parents</Col>
              </Row>

              { parents['collections'].length > 0 &&
                <>
                  <Row className="mb-3 align-items-center">
                    <Col className="h5 my-0 text-start">Collections</Col>
                  </Row>
                  <PaginatedList
                    list={parents['collections']}
                    name="Collections"
                    type="collection"
                  />
                </>
              }

              { parents['items'].length > 0 &&
                <>
                  <Row className="mb-3 align-items-center">
                    <Col className="h5 my-0 text-start">Items</Col>
                  </Row>
                  <PaginatedList
                    list={parents['items']}
                    name="Items"
                    type="item"
                  />
                </>
              }
            </>
          }
          {/* End Parents Section*/}
        </>
      }
    </>
  );
}
